import './App.css';
import { Helmet } from 'react-helmet';
import LandingPage from './unAuth/LandingPage';

//import { initializeApp } from "firebase/app"; 
import './firebase';
function App() {
  return (
    <>
      <Helmet>
        <title>My React App</title>
        <meta name="description" content="YouTube Video Metadata Extraction Tool" />
        <link rel="canonical" href="https://my-react-app.site" />
      </Helmet>
      <LandingPage />
    </>
  );
}

export default App;
